import(/* webpackMode: "eager" */ "/var/lib/circleci-runner/workdir/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/lib/circleci-runner/workdir/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/circleci-runner/workdir/frontend/xFrame4/components/next/ALink.tsx");
